import * as React from 'react';
import { getConnectorLetter } from '../../utils/connector';
import { capitalizeFirstLetter } from '../../utils/string';
import { OfflineIconPopup } from './OfflineIconPopup/OfflineIconPopup';


var ConnectorRowComponent = function (props) {
    var connector = props.connector, withImage = props.withImage, onClick = props.onClick;
    var health = connector.health, name = connector.name, imageUrl = connector.imageUrl;
    var _a = health || {}, connectorStage = _a.stage, connectorStatus = _a.status;
    var logoClasses = ['connector-logo'];
    if (withImage) {
        logoClasses.push('with-image');
    }
    var _b = React.useState(false), imageLoadError = _b[0], setImageLoadError = _b[1];
    var handleImageLoadError = React.useCallback(function () {
        setImageLoadError(true);
    }, []);
    var isOffline = connectorStatus === 'OFFLINE';
    var classNames = ['pluggy', 'connector-row'];
    if (isOffline) {
        classNames.push('offline');
    }
    var className = classNames.join(' ');
    return (React.createElement("div", { className: className, onClick: onClick },
        React.createElement("div", { className: logoClasses.join(' ') }, withImage && !imageLoadError ? (React.createElement("img", { alt: name, src: imageUrl, onError: handleImageLoadError })) : (getConnectorLetter(connector))),
        ' ',
        React.createElement("label", null, name),
        isOffline && React.createElement(OfflineIconPopup, null),
        connectorStage && (React.createElement("div", { className: 'connector-tag-container' },
            React.createElement("span", { className: 'connector-tag' }, capitalizeFirstLetter(connectorStage))))));
};
export var ConnectorRow = React.memo(ConnectorRowComponent);
